// extracted by mini-css-extract-plugin
export default {"totals":"wDzbRJnAkfDC+ZPZKqDqcQ==","total-amount":"REyMjdZiu+uQsx2yuukAow=="};